import { ForwardIcon, ReplyIcon } from 'foundations-assets';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const ResponseStatusIcon = ({
  forwarded,
  repliedTo
}) => {
  if (forwarded) {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: ForwardIcon,
      size: "400",
      color: 'icon-tertiary-default',
      padding: "0",
      marginInlineEnd: "100",
      marginBlock: "0",
      marginInlineStart: "0"
    });
  }
  if (repliedTo) {
    return /*#__PURE__*/_jsx(IconHolder, {
      icon: ReplyIcon,
      size: "400",
      color: 'icon-tertiary-default',
      padding: "0",
      marginInlineEnd: "100",
      marginBlock: "0",
      marginInlineStart: "0"
    });
  }
  return null;
};
ResponseStatusIcon.displayName = 'ResponseStatusIcon';
export default ResponseStatusIcon;